// 后台账号表单的草稿与换算（docs/04 第 9 节，决策 D43）。
import type { AdminUser, AdminUserInput, EntityStatus } from "@/app/master";
import { utf8Bytes } from "@/app/form";
import { operatorPasswordError } from "@/app/password";
import type { Errors } from "@/app/useDraft";

export interface AdminUserDraft { username: string; role: AdminUser["role"]; status: EntityStatus; password: string }

export function adminUserDraft(row?: AdminUser): AdminUserDraft {
  return row ? { username: row.username, role: row.role, status: row.status, password: "" } : { username: "", role: "viewer", status: "active", password: "" };
}

/** 新建必须给口令；给了口令就要满足复杂度规则（与服务端一致，D201）。 */
export function adminUserInput(d: AdminUserDraft, isNew: boolean): { body?: AdminUserInput; errors: Errors<AdminUserDraft> } {
  const errors: Errors<AdminUserDraft> = {};
  const username = d.username.trim();
  if (!username) errors.username = "填写用户名。";
  else if (utf8Bytes(username) > 64) errors.username = "用户名不超过 64 字节。";
  const password = isNew && !d.password ? "新建账号必须设置密码。" : d.password && operatorPasswordError(username, d.password);
  if (password) errors.password = password;
  if (Object.keys(errors).length) return { errors };
  return { errors, body: { username, role: d.role, status: d.status, password: d.password } };
}
